<script>
export default {
  name: "Footer"
}
</script>

<template>
  <footer>
    <div class="row col-12">
      <div class="col-3 d-flex align-items-center">
        <span> www.evollu.com </span>
      </div>
      <div class="col-2" style="width: 100%">
      </div>
      <div class="col-7 d-flex align-items-center">
        <span style="font-size: 12px"> Lorem ipsum dolor sit amet consectetur. Metus viverra amet tincidunt dictumst non bibendum pharetra. Eget pellentesque enim ultrices faucibus ac </span>
      </div>


    </div>
  </footer>
</template>

<style scoped lang="scss">
footer {
  color: white;
  //margin-left: -20px !important;
  width: 100%;
  height: 100px;
  background-image: url('~@/assets/check-up-reports/evollu-default/footer.svg');
  background-size: cover;
  display: flex;
  align-items: center;
}
</style>
